import React, { createContext, useContext, useState, useEffect } from 'react';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isUserAuthenticated, setIsUserAuthenticated] = useState(
//     () => JSON.parse(localStorage.getItem('isUserAuthenticated')) || false
//   );
//   const [userEmail, setUserEmail] = useState(
//     () => localStorage.getItem('user_email') || ''
//   );

//   const [isCompanyAuthenticated, setIsCompanyAuthenticated] = useState(
//     () => JSON.parse(localStorage.getItem('isCompanyAuthenticated')) || false
//   );
//   const [companyEmail, setCompanyEmail] = useState(
//     () => localStorage.getItem('company_email') || ''
//   );

//   useEffect(() => {
//     localStorage.setItem('isUserAuthenticated', JSON.stringify(isUserAuthenticated));
//     localStorage.setItem('user_email', userEmail);
//   }, [isUserAuthenticated, userEmail]);

//   useEffect(() => {
//     localStorage.setItem('isCompanyAuthenticated', JSON.stringify(isCompanyAuthenticated));
//     localStorage.setItem('company_email', companyEmail);
//   }, [isCompanyAuthenticated, companyEmail]);

//   // Check session age on mount and periodically
//   useEffect(() => {
//     const checkSessionAge = () => {
//       const loginTime = localStorage.getItem('loginTimestamp');
//       if (loginTime) {
//         const now = new Date().getTime();
//         const timeDiff = now - parseInt(loginTime);
//         const hoursDiff = timeDiff / (1000 * 60 * 60);
        
//         if (hoursDiff >= 24) {
//           logoutUser();
//           logoutCompany();
//         }
//       }
//     };

//     // Check immediately
//     checkSessionAge();
    
//     // Check every minute
//     const interval = setInterval(checkSessionAge, 60 * 1000);
    
//     return () => clearInterval(interval);
//   }, []);

//   const loginUser = (email) => {
//     setIsUserAuthenticated(true);
//     setUserEmail(email);
//     localStorage.setItem('loginTimestamp', new Date().getTime().toString());
//   };

//   const logoutUser = () => {
//     setIsUserAuthenticated(false);
//     setUserEmail('');
//     localStorage.clear();
//   };

//   const loginCompany = (email) => {
//     setIsCompanyAuthenticated(true);
//     setCompanyEmail(email);
//     localStorage.setItem('loginTimestamp', new Date().getTime().toString());
//   };

//   const logoutCompany = () => {
//     setIsCompanyAuthenticated(false);
//     setCompanyEmail('');
//     localStorage.clear();
//   };

//   return (
//     <AuthContext.Provider value={{
//       isUserAuthenticated,
//       loginUser,
//       logoutUser,
//       isCompanyAuthenticated,
//       loginCompany,
//       logoutCompany,
//       userEmail,
//       companyEmail
//     }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(() =>
    JSON.parse(localStorage.getItem('isUserAuthenticated')) || false
  );
  const [userEmail, setUserEmail] = useState(() =>
    localStorage.getItem('user_email') || ''
  );

  const [isCompanyAuthenticated, setIsCompanyAuthenticated] = useState(() =>
    JSON.parse(localStorage.getItem('isCompanyAuthenticated')) || false
  );
  const [companyEmail, setCompanyEmail] = useState(() =>
    localStorage.getItem('company_email') || ''
  );

  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() =>
    JSON.parse(localStorage.getItem('isAdminAuthenticated')) || false
  );
  const [adminEmail, setAdminEmail] = useState(() =>
    localStorage.getItem('admin_email') || ''
  );
  const [isSuperAdmin, setIsSuperAdmin] = useState(() =>
    JSON.parse(localStorage.getItem('is_super_admin')) || false
  );
  const [adminId, setAdminId] = useState(() =>
    parseInt(localStorage.getItem('admin_id')) || null
  );

  // Persist admin login
  useEffect(() => {
    localStorage.setItem('isAdminAuthenticated', JSON.stringify(isAdminAuthenticated));
    localStorage.setItem('admin_email', adminEmail);
    localStorage.setItem('is_super_admin', JSON.stringify(isSuperAdmin));
    localStorage.setItem('admin_id', adminId ? adminId.toString() : '');
  }, [isAdminAuthenticated, adminEmail, isSuperAdmin, adminId]);

  useEffect(() => {
    localStorage.setItem('isUserAuthenticated', JSON.stringify(isUserAuthenticated));
    localStorage.setItem('user_email', userEmail);
  }, [isUserAuthenticated, userEmail]);

  useEffect(() => {
    localStorage.setItem('isCompanyAuthenticated', JSON.stringify(isCompanyAuthenticated));
    localStorage.setItem('company_email', companyEmail);
  }, [isCompanyAuthenticated, companyEmail]);

  // Session Timeout - 24 hours
  useEffect(() => {
    const checkSessionAge = () => {
      const loginTime = localStorage.getItem('loginTimestamp');
      if (loginTime) {
        const now = Date.now();
        const timeDiff = now - parseInt(loginTime, 10);
        const hoursDiff = timeDiff / (1000 * 60 * 60);
        if (hoursDiff >= 24) {
          logoutUser();
          logoutCompany();
        }
      }
    };

    checkSessionAge();
    const interval = setInterval(checkSessionAge, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const loginAdmin = (email, isSuperAdminFlag = false, adminIdValue = null) => {
    setIsAdminAuthenticated(true);
    setAdminEmail(email);
    setIsSuperAdmin(isSuperAdminFlag);
    setAdminId(adminIdValue);
    localStorage.setItem('loginTimestamp', Date.now().toString());
  };
  
  const logoutAdmin = () => {
    setIsAdminAuthenticated(false);
    setAdminEmail('');
    setIsSuperAdmin(false);
    setAdminId(null);
    localStorage.removeItem('isAdminAuthenticated');
    localStorage.removeItem('admin_email');
    localStorage.removeItem('is_super_admin');
    localStorage.removeItem('admin_id');
    localStorage.removeItem('loginTimestamp');
    window.location.replace("/");
  };
  

  // LOGIN FUNCTIONS
  const loginUser = (email) => {
    setIsUserAuthenticated(true);
    setUserEmail(email);
    localStorage.setItem('loginTimestamp', Date.now().toString());
  };

  const loginCompany = (email) => {
    setIsCompanyAuthenticated(true);
    setCompanyEmail(email);
    localStorage.setItem('loginTimestamp', Date.now().toString());
  };

  // LOGOUT FUNCTIONS
  const logoutUser = () => {
    setIsUserAuthenticated(false);
    setUserEmail('');
    localStorage.removeItem('isUserAuthenticated');
    localStorage.removeItem('user_email');
    localStorage.removeItem('loginTimestamp');
    window.location.replace("/"); 
  };

  const logoutCompany = () => {
    setIsCompanyAuthenticated(false);
    setCompanyEmail('');
    localStorage.removeItem('isCompanyAuthenticated');
    localStorage.removeItem('company_email');
    localStorage.removeItem('loginTimestamp');
    window.location.replace("/");
  };

  return (
    <AuthContext.Provider value={{
      isUserAuthenticated,
      loginUser,
      logoutUser,
      userEmail,
      isCompanyAuthenticated,
      loginCompany,
      logoutCompany,
      companyEmail,
      isAdminAuthenticated,
      loginAdmin,
      logoutAdmin,
      adminEmail,
      isSuperAdmin,
      adminId
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
